import { Context, DRAWER_BREAKPOINT } from '@packages/layout/lib/UIShell/context';
import { createMemo } from '@packages/react';
import { useContext, useEffect } from 'react';

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: ShowSidebar
 * @date:  12.10.2019
 * @time:  18:47
 */
export const ShowSidebar = createMemo(
    () => {
        const [, { setDrawerHidden, setDrawer }] = useContext(Context);

        useEffect(() => {
            if (typeof window !== 'undefined' && window.innerWidth > DRAWER_BREAKPOINT) {
                setDrawerHidden(false);
                setDrawer(true);
            }
        }, ['']);

        return null;
    },
    {
        displayName: 'ShowSidebar',
    },
);
